import { useSignal } from '@preact/signals'

import { Button } from 'components'
import { NewSmartContractModal } from 'pages/components'
import { projectDetailsState } from 'state'

const NewSmartContractButton = () => {
	const isNewSmartContractModalOpen = useSignal(false)

	const openNewSmartContractModal = () => {
		isNewSmartContractModalOpen.value = true
	}

	const closeNewSmartContractModal = () => {
		isNewSmartContractModalOpen.value = false
	}

	return (
		<>
			<Button
				aria-label='New Smart Contract'
				onClick={openNewSmartContractModal}
				size='big'
				text='New Smart Contract'
				fullWidth
			/>
			{isNewSmartContractModalOpen.value && (
				<NewSmartContractModal
					defaultDAppName={{
						id: projectDetailsState.value!.publicId,
						name: projectDetailsState.value!.name
					}}
					isOpen={isNewSmartContractModalOpen.value}
					onClose={closeNewSmartContractModal}
				/>
			)}
		</>
	)
}

export { NewSmartContractButton }
